import React from 'react';
import { useLang } from '../../contexts/LangContext';
import { FUNCTION_ICON_OPTIONS } from '../../utils/functionIconOptions';

interface FunctionIconSelectProps {
  id?: string;
  name?: string;
  value?: string;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  disabled?: boolean;
  className?: string;
}

export const FunctionIconSelect: React.FC<FunctionIconSelectProps> = ({
  id,
  name,
  value = '',
  onChange,
  disabled = false,
  className = 'w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition-colors',
}) => {
  const { t } = useLang();

  return (
    <select
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      disabled={disabled}
      className={className}
    >
      <option value="">{t('select')} icon</option>
      {FUNCTION_ICON_OPTIONS.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};
